import { getPedidos } from "@spark/services/pedidos";
import { getOperacoes } from "@spark/services/operacoes";
import { useState, useEffect, useCallback, useRef } from 'react';
import { notification } from '@spark/ui-components/utils/notification';

export const usePedidosTab = depotId => {
  const [pedidos, setPedidos] = useState([]);
  const [loading, setLoading] = useState(true);
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const loadPedidos = useCallback(async () => {
    if (!depotId || !isMountedRef.current) return;

    try {
      setLoading(true);
      const response = await getPedidos({ DepotId: depotId });

      if (isMountedRef.current) {
        const pedidosArray = Array.isArray(response)
          ? response
          : response?.registros || response?.data || [];

        const tipoOperacaoSet = new Set(
          pedidosArray
            .map(pedido =>
              pedido.TipoDeOperacao ??
              pedido.tipoDeOperacao ??
              pedido.TipoDaOperacao ??
              pedido.tipoDaOperacao ??
              ''
            )
            .filter(Boolean)
        );
        const tipoOperacaoList = Array.from(tipoOperacaoSet);
        const operacaoNomePorTipo = {};

        if (tipoOperacaoList.length > 0) {
          const operacoes = await Promise.all(
            tipoOperacaoList.map(async tipo => {
              try {
                // Gambiarra pq o backend n�o me trouxe nome da opera��o na listagem.
                const operacaoResponse = await getOperacoes({ TipoDaOperacao: tipo });
                const registros = Array.isArray(operacaoResponse)
                  ? operacaoResponse
                  : operacaoResponse?.registros || operacaoResponse?.data || [];
                const operacao = Array.isArray(registros) ? registros[0] : registros;
                return { tipo, nome: operacao?.NomeOperacao ?? operacao?.nomeOperacao ?? '' };
              } catch (error) {
                console.error('Erro ao carregar operacao:', error);
                return { tipo, nome: '' };
              }
            })
          );

          operacoes.forEach(({ tipo, nome }) => {
            if (nome) {
              operacaoNomePorTipo[tipo] = nome;
            }
          });
        }

        const dadosProcessados = pedidosArray.map(pedido => ({
          tipoDeOperacao:
            pedido.TipoDeOperacao ??
            pedido.tipoDeOperacao ??
            pedido.TipoDaOperacao ??
            pedido.tipoDaOperacao ??
            '',
          id: pedido.Id ?? pedido.id,
          NumeroPedidoEmbarcador:
            pedido.NumeroPedidoEmbarcador ??
            pedido.numeroPedidoEmbarcador ??
            '',
          numeroDoPedido: pedido.NumeroDoPedido ?? pedido.numeroDoPedido ?? '',
          dataIntegracao: pedido.DataIntegracao
            ? new Date(pedido.DataIntegracao).toLocaleString('pt-BR')
            : '',
          nomeOperacao:
            pedido.NomeOperacao ??
            pedido.nomeOperacao ??
            operacaoNomePorTipo[
              pedido.TipoDeOperacao ??
              pedido.tipoDeOperacao ??
              pedido.TipoDaOperacao ??
              pedido.tipoDaOperacao ??
              ''
            ] ??
            '',
          statusPedidoEmissaoTMS: pedido.StatusPedidoEmissaoTMS ?? pedido.statusPedidoEmissaoTMS ?? ''
        }));
        console.log('Pedidos processados para tabela:', dadosProcessados);
        setPedidos(dadosProcessados);
      }
    } catch (error) {
      console.error('Erro ao carregar pedidos:', error);

      if (isMountedRef.current) {
        notification.error('Erro ao carregar pedidos');
        setPedidos([]);
      }
    } finally {
      if (isMountedRef.current) {
        setLoading(false);
      }
    }
  }, [depotId]);

  useEffect(() => {
    if (depotId) {
      loadPedidos();
    }
  }, [depotId, loadPedidos]);
  return {
    pedidos,
    loading,
    loadPedidos
  };
};
